export enum DYNAMIC_PROCESS_TABS {
  BASE_KEY = "base",
  PATH_KEY = "path",
  TEMPLATES_KEY = "templates",
  DYNAMIC_ATTRIBUTES_KEY = "dynamic-attributes",
}
